
export default "/assets/twitter.9c532486.svg"